export { VitalsTable } from './VitalsTable';
export type { VitalsData, VitalsTableProps } from './VitalsTable';

